import React from "react";
import '../../../styles/components/ClientsReview.css';

const reviews = [
  {
    name: "Sarah T",
    country: "USA",
    flag: "us",
    review: "DEZINE's graphic design skills are outstanding! They not only created stunning visuals but also optimized my website for SEO, boosting our online presence! Highly recommended!",
    rating: 5,
    image: "client1.png",
  },
  {
    name: "John P.",
    country: "UK",
    flag: "uk",
    review: "The graphic designs from DEZINE were just what I needed! Their digital marketing strategies helped my brand reach a wider audience effectively!",
    rating: 5,
    image: "client2.jpeg",
  },
  {
    name: "Emily R.",
    country: "Canada",
    flag: "ca",
    review: "I'm thrilled with the graphic design work from DEZINE. They revamped my website and improved its SEO, making it much more user-friendly and visible!",
    rating: 5,
    image: "client3.jpeg",
  },
  {
    name: "Liam S.",
    country: "Australia",
    flag: "au",
    review: "Dezine created eye-catching graphics for my marketing campaign and their web development skills ensured my site ran smoothly. Highly recommended!",
    rating: 5,
    image: "client4.jpeg",
  },
  {
    name: "Anna M.",
    country: "Germany",
    flag: "de",
    review: "Die Grafikdesign-Dienstleistungen von Dezine sind hervorragend! Sie haben nicht nur großartige Designs geliefert, sondern auch meine Website für SEO optimiert.",
    rating: 5,
    image: "client5.jpeg",
  },
  {
    name: "Jorge B.",
    country: "USA",
    flag: "us",
    review: "Dezine took my branding to the next level! Their graphic design is stunning, and their digital marketing expertise helped us grow our online presence significantly.",
    rating: 5,
    image: "client6.jpeg",
  },
];

const ClientsReview = () => {
  return (
    <section className="clients-review">
      <h2>Clients Review_</h2>
      <div className="carousel">
        <button className="prev-btn">❮</button>
        <div className="reviews-container">
          {reviews.map((client, index) => (
            <div key={index} className="review-card">
            <img src={`/images/reviews/${client.image}`} alt={client.name} className="client-image" />
            <h4>{client.name}</h4>
            <p className="client-country">
              <img src={`/images/flags/${client.flag}.svg`} alt="flag" className="flag-icon" />
              <em>{client.city ? `${client.city}, ${client.country}` : `${client.country}`}</em>
            </p>
            <div className="rating">
              {Array.from({ length: client.rating }, (_, i) => (
                <span key={i} className="star">★</span>
              ))}
            </div>
            <p className="client-review"><em>{client.review}</em></p>
          </div>          
          ))}
        </div>
        <button className="next-btn">❯</button>
      </div>
    </section>
  );
};

export default ClientsReview;
